import React from 'react';
import { useSetRecoilState } from 'recoil';
import { timeSavedMetric } from '../../../recoil/atoms/timeSavedMetric';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

export function TimeSavedMetrics() {
  const setTimeMetric = useSetRecoilState(timeSavedMetric);
  const metrics = [
    {
      title: 'Total Time Saved',
      key: 'total',
    },
    {
      title: 'Click-to-Call',
      key: 'c2c',
    },
    {
      title: 'Logged Call',
      key: 'loggedCall',
    },
    {
      title: 'Auto-SMS',
      key: 'autoSMS',
    },
    {
      title: 'SMS Template',
      key: 'smsTemplate',
    },
    {
      title: 'Incoming Call',
      key: 'incomingCall',
    },
  ];
  const useStyles = makeStyles((theme) => ({
    metricDropdown: {
      marginLeft: '1vw',
      marginTop: '10px',
    },
  }));
  function metricHandler(e) {
    const [title, key] = e.target.value.split(',');
    setTimeMetric({
      title,
      key,
    });
  }
  const classes = useStyles();
  return (
    <span>
      <FormControl
        className={classes.metricDropdown}
        size="small"
        variant="outlined"
      >
        <InputLabel>Metric</InputLabel>
        <Select
          defaultValue={'Total Time Saved,total'}
          onChange={metricHandler}
          label="Team"
        >
          {metrics?.map((metric, index) => (
            <MenuItem key={index} value={`${metric.title},${metric.key}`}>
              {metric.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </span>
  );
}
